import { createAction } from 'redux-actions';

export const fetchRolePolicies = createAction('FETCH_ROLE_POLICIES');
export const fetchRolePoliciesSuccess = createAction('FETCH_ROLE_POLICIES_SUCCESS');
export const fetchRolePoliciesFailure = createAction('FETCH_ROLE_POLICIES_FAILURE');
